window.INVELO_HW_POOL = {
  'outlet-cabina.es': { '55127765320022': '59214497579353' },
  'h19yvc-sy.myshopify.com': { '55127765320022': '59214497579353' },
  'outletcabina.es': { '55127765320022': '58564212425078' },
  'wwv336-zq.myshopify.com': { '55127765320022': '58564212425078' }
};
window.INVELO_HW_FALLBACK_SHOP = 'outlet-cabina.es';

(function () {
  function readDrState() {
    var scripts = document.querySelectorAll('script[data-dr-injected="true"]');
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent || '';
      var shop = (t.match(/shopDomain:\s*'([^']+)'/) || [])[1];
      var mapRaw = (t.match(/MAP_STANDARD:\s*(\{[\s\S]*?\})/) || [])[1];
      if (!shop || !mapRaw) continue;
      try {
        return { shopDomain: shop, MAP_STANDARD: JSON.parse(mapRaw) };
      } catch (e) {}
    }
    return null;
  }
  function cookieGet(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  function attrQuery(extra) {
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem('dr_attr') || '{}'); } catch (e) {}
    try {
      var p = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'ttclid', 'sck', 'xcod'].forEach(function (k) {
        var v = p.get(k); if (v) stored[k] = v;
      });
    } catch (e) {}
    var fbp = cookieGet('_fbp');
    if (fbp) { stored._fbp = fbp; stored.fbp = fbp; }
    if (extra) Object.keys(extra).forEach(function (k) { if (extra[k]) stored[k] = extra[k]; });
    try { localStorage.setItem('dr_attr', JSON.stringify(stored)); } catch (e) {}
    var parts = [];
    Object.keys(stored).forEach(function (k) {
      if (!stored[k]) return;
      parts.push(k + '=' + encodeURIComponent(stored[k]));
      parts.push('attributes[' + k + ']=' + encodeURIComponent(stored[k]));
    });
    return parts.join('&');
  }
  function mapWhiteVariant(vid) {
    vid = String(vid);
    var state = readDrState();
    var shop = (state && state.shopDomain) || window.INVELO_HW_FALLBACK_SHOP;
    if (shop.indexOf('delurtwo') !== -1 || shop.indexOf('0g8ice-du') !== -1) {
      shop = window.INVELO_HW_FALLBACK_SHOP;
    }
    var dest = null;
    if (state && state.MAP_STANDARD && state.MAP_STANDARD[vid]) dest = String(state.MAP_STANDARD[vid]);
    var pool = window.INVELO_HW_POOL || {};
    if (!dest && pool[shop] && pool[shop][vid]) dest = String(pool[shop][vid]);
    if (!dest) {
      var shops = Object.keys(pool);
      for (var i = 0; i < shops.length; i++) {
        if (pool[shops[i]][vid]) {
          dest = String(pool[shops[i]][vid]);
          shop = shops[i];
          break;
        }
      }
    }
    return { shop: shop, dest: dest };
  }

  var burger = document.getElementById('hwBurger');
  var nav = document.getElementById('hwNav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var main = document.getElementById('hwMain');
  var thumbBtns = document.querySelectorAll('#hwThumbs .hw-thumb');
  var galI = 0;
  function galShow(n) {
    if (!main || !thumbBtns.length) return;
    galI = (n + thumbBtns.length) % thumbBtns.length;
    var btn = thumbBtns[galI];
    var img = btn.querySelector('img');
    var full = img.getAttribute('data-full') || img.src;
    var set = img.getAttribute('data-srcset') || '';
    main.setAttribute('src', full);
    if (set) main.setAttribute('srcset', set);
    else main.removeAttribute('srcset');
    thumbBtns.forEach(function (b, k) { b.classList.toggle('on', k === galI); });
    btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
  thumbBtns.forEach(function (btn, k) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      galShow(k);
    });
  });
  document.querySelectorAll('#hwGallery [data-gal]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      galShow(galI + parseInt(btn.getAttribute('data-gal'), 10));
    });
  });
  var stage = document.getElementById('hwStage');
  if (stage && main && thumbBtns.length) {
    var sx = 0;
    stage.addEventListener('touchstart', function (e) { sx = e.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (dx > 40) galShow(galI - 1);
      if (dx < -40) galShow(galI + 1);
    }, { passive: true });
  }

  var sticky = document.getElementById('hwSticky');
  var buyBox = document.getElementById('buy');
  if (sticky && buyBox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('off', entries[0].isIntersecting);
    }, { threshold: 0.35 });
    io.observe(buyBox);
  }

  var busy = false;
  function buy(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (busy) return;
    var idEl = document.getElementById('hw-variant');
    var id = idEl ? parseInt(idEl.value, 10) : 0;
    if (!id) return;
    var mapped = mapWhiteVariant(id);
    if (!mapped.dest || !mapped.shop) return;
    busy = true;
    var buttons = [document.getElementById('hwBuy'), document.getElementById('hwBuySticky'), document.getElementById('hwBuyMid')];
    buttons.forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Adding…'; } });
    try {
      var p = window.INVELO_TT || {};
      var payload = {
        contents: [{ content_id: String(mapped.dest), content_name: p.content_name || '', quantity: 1, price: p.value || 59 }],
        content_id: String(p.content_id || id),
        content_type: 'product',
        content_name: p.content_name || '',
        value: p.value || 59,
        currency: p.currency || 'GBP',
        event_id: 'invelo.tt.atc.' + id
      };
      if (window.ttq && typeof ttq.track === 'function') {
        ttq.track('AddToCart', payload);
        ttq.track('InitiateCheckout', payload);
      }
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', { value: payload.value, currency: payload.currency, content_ids: [String(mapped.dest)], content_type: 'product' });
        fbq('track', 'InitiateCheckout', { value: payload.value, currency: payload.currency, content_ids: [String(mapped.dest)], content_type: 'product' });
      }
    } catch (err) {}
    var qs = attrQuery({ event_id: 'invelo.tt.ic.' + id });
    var url = 'https://' + mapped.shop + '/cart/' + mapped.dest + ':1?country=GB&localization[country]=GB';
    if (qs) url += '&' + qs;
    setTimeout(function () { window.location.href = url; }, 350);
  }

  ['hwBuy', 'hwBuySticky', 'hwBuyMid'].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', buy);
  });
  var form = document.getElementById('hw-form');
  if (form) form.addEventListener('submit', buy);

  var ugc = document.getElementById('hwUgc');
  if (ugc) {
    var slides = ugc.querySelectorAll('.hw-ugc-slide');
    var dots = ugc.querySelectorAll('[data-ugc-go]');
    var label = document.getElementById('hwUgcN');
    var i = 0;
    var total = slides.length;
    function show(n) {
      i = (n + total) % total;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      if (label) label.textContent = String(i + 1);
    }
    ugc.querySelectorAll('[data-ugc]').forEach(function (btn) {
      btn.addEventListener('click', function () { show(i + parseInt(btn.getAttribute('data-ugc'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-ugc-go'), 10)); });
    });
    var startX = 0;
    var view = ugc.querySelector('.hw-ugc-view');
    if (view) {
      view.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
      view.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (dx > 40) show(i - 1);
        if (dx < -40) show(i + 1);
      }, { passive: true });
    }
  }
})();
